import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/Products/ProductDetail';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/News/NewsDetail';



const AppRoutes = () => (
  <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/products' element={<Products />} />
    <Route path='/products/:slug' element={<ProductDetail />} />
    <Route path='/contact' element={<Contact />} />
    <Route path='/news' element={<News />} />
    <Route path='/news/:id' element={<NewsDetail />} />
  </Routes>
);

export default AppRoutes;
